var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipseRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 200,
    viewBox: "0 0 221 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 37.6377,
    width: 78.088,
    height: 78.088,
    fill: "url(#pattern0_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8022,
    y: 25.1426,
    width: 37.4823,
    height: 103.076,
    fill: "url(#pattern1_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9375,
    y: 37.6377,
    width: 78.088,
    height: 78.088,
    fill: "url(#pattern2_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3318,
    y: 62.627,
    width: 162.423,
    height: 28.1117,
    fill: "url(#pattern3_3654_4710)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4435,
    y: 56.3809,
    width: 103.076,
    height: 40.6058,
    fill: "url(#pattern4_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82.4316,
    y: 12.6504,
    width: 56.2234,
    height: 124.941,
    fill: "url(#pattern5_3654_4710)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88.6787,
    y: 37.6387,
    width: 43.7293,
    height: 78.088,
    fill: "url(#pattern6_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82.4316,
    y: 12.6504,
    width: 56.2234,
    height: 124.941,
    fill: "url(#pattern7_3654_4710)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 88.6787,
    y: 37.6387,
    width: 43.7293,
    height: 78.088,
    fill: "url(#pattern8_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 48.073,
    y: 47.0078,
    width: 124.941,
    height: 56.2234,
    fill: "url(#pattern9_3654_4710)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9376,
    y: 53.2559,
    width: 81.2115,
    height: 43.7293,
    fill: "url(#pattern10_3654_4710)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 48.073,
    y: 47.0078,
    width: 124.941,
    height: 56.2234,
    fill: "url(#pattern11_3654_4710)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 69.9376,
    y: 53.2559,
    width: 81.2115,
    height: 43.7293,
    fill: "url(#pattern12_3654_4710)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5325 107.325H155.77V173.606L110.136 199.938L64.5325 173.606V107.325Z",
    fill: "url(#paint0_radial_3654_4710)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 195.002L64.5325 168.765V173.731L110.136 200L155.77 173.669V168.765L110.136 195.002ZM64.5325 163.767L110.136 190.13L155.77 163.767V158.738L110.136 185.07L64.5325 158.738V163.673V163.767Z",
    fill: "url(#paint1_linear_3654_4710)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6202 129.285H138.687V158.677L110.138 175.17L81.6202 158.677V129.285Z",
    fill: "url(#paint2_radial_3654_4710)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.138 170.203L81.6202 153.742V158.677L110.138 175.17L138.687 158.677V153.742L110.138 170.203Z",
    fill: "url(#paint3_linear_3654_4710)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.524 85.9922C28.5501 86.5544 47.7909 92.2392 49.0091 98.4862C49.7586 103.681 51.2524 108.741 53.4445 113.51C44.074 107.013 42.6996 100.704 34.9533 96.8933C28.2064 93.7697 21.5534 90.6462 17.524 85.9297V85.9922Z",
    fill: "url(#paint4_radial_3654_4710)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8851 101.359C41.7313 94.862 24.7706 89.7082 17.524 85.9912C28.5501 86.5534 47.7909 92.2383 49.0091 98.4853C49.7586 103.68 51.2524 108.74 53.4445 113.509C51.5126 109.307 49.3219 105.228 46.8851 101.296V101.359Z",
    fill: "url(#paint5_radial_3654_4710)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.446 100.796C48.7588 97.1099 30.8922 89.3635 26.9254 87.7081C18.8042 84.2722 10.683 80.7426 5.62293 71.4345C4.58356 69.4212 3.69616 67.3331 2.96802 65.1875C6.5913 66.843 10.2146 68.311 13.7754 70.2164C21.3968 73.9958 29.6429 78.0876 37.0456 82.3044C43.5113 85.9901 47.5719 88.8325 48.3528 93.9551C48.5402 95.6106 49.1649 99.2963 49.446 100.858V100.796Z",
    fill: "url(#paint6_radial_3654_4710)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5742 90.1757C28.737 81.9608 13.6817 79.7119 2.96802 65.1875C6.5913 66.843 10.2146 68.311 13.7754 70.2164C21.3968 73.9958 29.6429 78.0876 37.0456 82.3044C43.5113 85.9901 47.5719 88.8325 48.3528 93.9551C48.5402 95.6106 49.1649 99.2963 49.446 100.858V100.483C47.9155 95.7043 47.0097 92.7994 42.6992 90.2381L42.5742 90.1757Z",
    fill: "url(#paint7_radial_3654_4710)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3851 94.3305C47.7292 89.8638 42.9815 86.2093 37.0156 82.8047C30.2063 78.9627 22.6161 75.6206 15.9318 71.7162C3.43773 64.3759 0.314209 59.2221 0.314209 43.6045C5.05376 48.6962 10.3921 53.1956 16.2129 57.0044C24.584 62.6267 46.4174 73.5278 47.4481 84.5226C47.6668 87.8648 47.9479 91.1445 48.354 94.3305H48.3851Z",
    fill: "url(#paint8_radial_3654_4710)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3228 82.8057C38.513 76.0589 24.1448 69.4683 16.2111 64.7205C7.02793 59.1294 2.62376 54.163 0 43.6992C4.84203 48.7778 10.286 53.2463 16.2111 57.0054C24.5821 62.6278 46.4155 73.5288 47.4463 84.5236C47.6649 87.8658 47.9461 91.1455 48.3521 94.3315C48.367 94.1027 48.367 93.8731 48.3521 93.6443C47.8089 89.7825 46.4341 86.0846 44.3228 82.8057Z",
    fill: "url(#paint9_radial_3654_4710)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6047 86.5854C46.8551 78.5891 36.6725 71.6862 20.8987 62.0033C7.59248 53.8509 -0.0913789 44.8551 2.15756 27.6445C10.6147 37.3389 20.5059 45.6816 31.4875 52.3828C42.2948 59.5357 46.3242 66.5948 47.1051 76.6838V79.2451C47.1051 81.6814 47.3549 84.1178 47.5423 86.5229L47.6047 86.5854Z",
    fill: "url(#paint10_radial_3654_4710)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6085 62.5635C20.2091 51.8811 5.5597 47.883 2.21753 27.6113C10.6746 37.3057 20.5658 45.6484 31.5474 52.3496C42.3548 59.5025 46.3842 66.5616 47.165 76.6506V79.2119C47.165 81.6482 47.4149 84.0846 47.6023 86.4897C47.6194 86.3131 47.6194 86.1353 47.6023 85.9587C47.305 81.34 45.985 76.8451 43.7378 72.799C41.4906 68.753 38.3724 65.2569 34.6085 62.5635Z",
    fill: "url(#paint11_radial_3654_4710)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1658 78.8693C45.9164 64.2825 36.296 56.5986 25.5823 49.2583C20.8317 46.1857 16.4141 42.6265 12.401 38.6384C6.68499 32.5787 4.06123 25.4883 6.15399 13.2441C13.0575 20.257 20.7633 26.4321 29.1119 31.6417C44.4171 41.7931 46.6036 46.7595 46.7285 62.8769C46.7285 68.1244 46.7285 73.5906 47.0721 78.9942L47.1658 78.8693Z",
    fill: "url(#paint12_radial_3654_4710)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5717 71.935C44.2291 56.5673 41.6053 51.4447 30.1733 43.3236C16.4922 33.547 8.02748 29.5489 6.24707 13.1191C13.1506 20.132 20.8564 26.3071 29.205 31.5167C44.5102 41.6681 46.6966 46.6345 46.8216 62.7519C46.8216 67.9994 46.8216 73.4656 47.1652 78.8693C46.9778 76.5578 46.9153 74.2777 46.5717 72.06V71.935Z",
    fill: "url(#paint13_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84192 16.6787C7.12771 22.4173 9.58422 27.8327 13.7137 31.8278C18.3053 36.4194 28.2693 42.1354 34.079 46.3209C27.832 40.6361 19.8045 36.4194 14.6195 31.0157C10.7843 27.0234 8.09739 22.0704 6.84192 16.6787Z",
    fill: "url(#paint14_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06299 34.8594C6.06204 48.4155 26.4899 56.724 35.9229 63.6895C27.6456 55.6308 8.81074 48.884 4.06299 34.8594Z",
    fill: "url(#paint15_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1261 49.6348C5.46827 61.4417 20.1489 67.6887 28.4575 71.4994C22.2104 67.595 7.65473 61.6291 2.1261 49.6348Z",
    fill: "url(#paint16_radial_3654_4710)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.782 85.9922C191.756 86.5544 172.515 92.2392 171.297 98.4862C170.547 103.681 169.053 108.741 166.861 113.51C176.232 107.013 177.606 100.704 185.353 96.8933C192.099 93.7697 198.721 90.6462 202.782 85.9297V85.9922Z",
    fill: "url(#paint17_radial_3654_4710)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.421 101.359C178.574 94.862 195.535 89.7082 202.782 85.9912C191.756 86.5534 172.515 92.2383 171.297 98.4853C170.547 103.68 169.053 108.74 166.861 113.509C168.781 109.301 170.972 105.221 173.421 101.296V101.359Z",
    fill: "url(#paint18_radial_3654_4710)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.857 100.796C171.544 97.1099 189.411 89.3635 193.346 87.7081C201.499 84.2722 209.62 80.7426 214.68 71.4345C215.72 69.4212 216.607 67.3331 217.335 65.1875C213.712 66.843 210.089 68.311 206.528 70.2164C198.906 73.9958 190.66 78.0876 183.258 82.3044C176.792 85.9901 172.7 88.8325 171.95 93.9551C171.763 95.6106 171.138 99.2963 170.857 100.858V100.796Z",
    fill: "url(#paint19_radial_3654_4710)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.729 90.1757C191.567 81.9608 206.622 79.7119 217.336 65.1875C213.712 66.843 210.089 68.311 206.528 70.2164C198.907 73.9958 190.661 78.0876 183.258 82.3044C176.792 85.9901 172.701 88.8325 171.951 93.9551C171.764 95.6106 171.139 99.2963 170.858 100.858C170.849 100.733 170.849 100.608 170.858 100.483C172.388 95.7043 173.294 92.7994 177.605 90.2381L177.729 90.1757Z",
    fill: "url(#paint20_radial_3654_4710)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.921 94.3305C172.577 89.8638 177.324 86.2093 183.29 82.8047C190.1 78.9627 197.69 75.6206 204.374 71.7162C216.868 64.3759 219.992 59.2221 219.992 43.6045C215.169 48.6791 209.746 53.1474 203.843 56.9107C195.472 62.533 173.639 73.4341 172.608 84.4289C172.389 87.7711 172.108 91.0508 171.702 94.2368L171.921 94.3305Z",
    fill: "url(#paint21_radial_3654_4710)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.918 82.8057C181.728 76.0589 196.065 69.4683 204.03 64.7205C213.213 59.1294 217.617 54.163 220.241 43.6992C215.418 48.7738 209.995 53.2422 204.092 57.0054C195.721 62.6278 173.888 73.5288 172.857 84.5236C172.638 87.8658 172.357 91.1455 171.951 94.3315C171.936 94.1027 171.936 93.8731 171.951 93.6443C172.447 89.7947 173.768 86.0976 175.824 82.8057H175.918Z",
    fill: "url(#paint22_radial_3654_4710)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.7 86.5854C173.449 78.5891 183.632 71.6862 199.406 62.0033C212.681 53.8509 220.396 44.8551 218.147 27.6445C209.683 37.3319 199.793 45.6736 188.817 52.3828C178.01 59.5357 173.949 66.5948 173.199 76.6838V79.2451C173.199 81.6814 172.949 84.1178 172.762 86.5229L172.7 86.5854Z",
    fill: "url(#paint23_radial_3654_4710)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.694 62.5635C200.094 51.8811 214.743 47.883 218.085 27.6113C209.621 37.2987 199.731 45.6404 188.755 52.3496C177.948 59.5025 173.887 66.5616 173.137 76.6506V79.2119C173.137 81.6482 172.888 84.0846 172.7 86.4897C172.683 86.3131 172.683 86.1353 172.7 85.9587C172.998 81.34 174.317 76.8451 176.565 72.799C178.812 68.753 181.93 65.2569 185.694 62.5635Z",
    fill: "url(#paint24_radial_3654_4710)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.139 78.8693C174.388 64.2825 184.009 56.5986 194.722 49.2583C199.469 46.1933 203.877 42.6334 207.872 38.6384C213.62 32.5787 216.243 25.4883 214.119 13.2441C207.206 20.2589 199.49 26.4341 191.13 31.6417C175.825 41.7931 173.639 46.7595 173.514 62.8769C173.514 68.1244 173.514 73.5906 173.17 78.9942L173.139 78.8693Z",
    fill: "url(#paint25_radial_3654_4710)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.732 71.935C176.074 56.5673 178.698 51.4447 190.13 43.3236C203.811 33.547 212.276 29.5489 214.056 13.1191C207.169 20.1739 199.474 26.391 191.13 31.6416C175.824 41.7931 173.638 46.7595 173.513 62.8768C173.513 68.1243 173.513 73.5905 173.169 78.9942C173.357 76.6828 173.419 74.4026 173.763 72.1849L173.732 71.935Z",
    fill: "url(#paint26_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.556 16.6787C213.271 22.4173 210.814 27.8327 206.685 31.8278C202.093 36.4194 192.129 42.1354 186.319 46.3209C192.566 40.6361 200.594 36.4194 205.779 31.0157C209.614 27.0234 212.301 22.0704 213.556 16.6787Z",
    fill: "url(#paint27_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.117 34.8594C214.118 48.4155 193.69 56.724 184.257 63.6895C192.535 55.6308 211.369 48.884 216.117 34.8594Z",
    fill: "url(#paint28_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.181 49.6348C214.839 61.4417 200.158 67.6887 191.849 71.4994C198.097 67.595 212.621 61.6291 218.181 49.6348Z",
    fill: "url(#paint29_radial_3654_4710)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6024 41.0422L110.136 6.08996V0.155273L44.4797 38.0748L49.6024 41.0422Z",
    fill: "url(#paint30_radial_3654_4710)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.138 6.08996L170.703 41.0422L175.825 38.0748L110.138 0.155273V6.08996Z",
    fill: "url(#paint31_radial_3654_4710)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.986 14.9938L110.138 9.71508V6.0918L49.6042 41.044L52.759 42.8556L76.3728 29.2058L100.986 14.9938Z",
    fill: "url(#paint32_radial_3654_4710)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.138 9.71508L138.843 26.2697L167.548 42.8556L170.703 41.044L110.138 6.0918V9.71508Z",
    fill: "url(#paint33_radial_3654_4710)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6024 110.949V41.0445L44.4797 38.0771V113.916L49.6024 110.949Z",
    fill: "url(#paint34_radial_3654_4710)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 41.0449V110.949L52.759 109.138V75.9971V42.8566L49.6042 41.0449Z",
    fill: "url(#paint35_radial_3654_4710)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.548 63.1907V75.9971V109.138L170.702 110.949V41.0449L167.548 42.8566V63.1907Z",
    fill: "url(#paint36_radial_3654_4710)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.702 41.0445V110.949L175.824 113.916V38.0771L170.702 41.0445Z",
    fill: "url(#paint37_radial_3654_4710)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4329 125.724L70.3756 119.32L52.759 109.138L49.6042 110.949L110.138 145.902V142.278L81.4329 125.724Z",
    fill: "url(#paint38_radial_3654_4710)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 145.901L49.6024 110.949L44.4797 113.917L110.136 151.836V145.901Z",
    fill: "url(#paint39_radial_3654_4710)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.38 132.908L110.138 142.278V145.902L170.703 110.949L167.548 109.138L150.993 118.696L138.843 125.724L126.38 132.908Z",
    fill: "url(#paint40_radial_3654_4710)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.703 110.949L110.138 145.901V151.836L175.825 113.917L170.703 110.949Z",
    fill: "url(#paint41_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 0.0937078V6.0284L49.6024 41.0431L44.4797 37.9195C51.2578 37.9195 57.4112 35.2645 72.0917 26.5499L86.4911 18.2414C101.39 9.87033 106.825 5.90345 110.136 0V0.0937078Z",
    fill: "url(#paint42_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.548 109.138L170.672 110.949L110.138 145.902V142.403C113.105 143.653 117.853 140.092 132.627 131.565L147.026 123.256C161.832 114.698 166.861 112.292 167.548 109.138Z",
    fill: "url(#paint43_radial_3654_4710)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7582 109.137L110.137 142.277L167.548 109.137V42.8554L110.137 9.71484L52.7582 42.8554V109.137Z",
    fill: "#0EC89C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 75.9947L52.759 83.0851L58.7561 75.9947L52.759 68.873L49.6042 75.9947Z",
    fill: "#868686"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7582 109.137L110.137 142.277L167.548 109.137V42.8554L110.137 9.71484L52.7582 42.8554V109.137Z",
    fill: "#0EC89C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.981 10.9645L110.136 6.0918L112.323 10.9645V24.8017L110.136 26.3322L107.981 24.8017V10.9645Z",
    fill: "#F56D00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.391 41.5759L170.701 41.0449L167.546 45.3554L155.551 52.2896L153.178 51.1651L153.365 48.5101L165.391 41.5759Z",
    fill: "#F56D00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.546 106.605L170.701 110.947L165.391 110.385L153.365 103.45L153.178 100.827L155.551 99.7021L167.546 106.605Z",
    fill: "#F56D00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.981 141.029L110.136 145.902L112.323 141.029V127.16L110.136 125.661L107.981 127.16V141.029Z",
    fill: "#F56D00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.759 106.605L49.6042 110.947L54.9143 110.385L66.9397 103.45L67.1584 100.827L64.7533 99.7021L52.759 106.605Z",
    fill: "#F56D00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9143 41.5759L49.6042 41.0449L52.759 45.3554L64.7533 52.2896L67.1584 51.1651L66.9397 48.5101L54.9143 41.5759Z",
    fill: "#F56D00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7553 97.0175V54.9437L52.7582 45.3545V106.607L58.7553 97.0175Z",
    fill: "url(#paint44_radial_3654_4710)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7551 54.9431V97.0169L64.7523 99.7031V52.2881L58.7551 54.9431Z",
    fill: "url(#paint45_radial_3654_4710)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7582 45.3545L58.7553 54.9437L64.7525 52.2887L52.7582 45.3545Z",
    fill: "url(#paint46_radial_3654_4710)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7582 106.608L58.7553 97.0186L64.7525 99.7048L52.7582 106.608Z",
    fill: "url(#paint47_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7892 47.042L58.0997 55.413L58.7556 72.6549L59.2241 55.5692L63.066 53.0392L58.9118 54.4135L53.7892 47.042Z",
    fill: "url(#paint48_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7892 104.951L58.0997 96.5795L58.7556 87.0527L59.2241 96.4233L63.066 98.9534L58.9118 97.579L53.7892 104.951Z",
    fill: "url(#paint49_radial_3654_4710)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.083 109.979L117.632 131.031L112.322 141.026L165.39 110.385L154.083 109.979Z",
    fill: "url(#paint50_radial_3654_4710)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.632 131.032L154.083 109.979L153.396 103.451L112.322 127.159L117.632 131.032Z",
    fill: "url(#paint51_radial_3654_4710)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.322 141.027L117.632 131.031L112.322 127.158V141.027Z",
    fill: "url(#paint52_radial_3654_4710)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.392 110.385L154.085 109.979L153.367 103.451L165.392 110.385Z",
    fill: "url(#paint53_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.261 139.279L118.352 131.345L132.971 122.162L117.915 130.314L113.792 128.222L117.072 131.158L113.261 139.279Z",
    fill: "url(#paint54_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.424 110.323L154.023 110.76L145.433 114.977L153.304 109.886L153.585 105.263L154.46 109.573L163.424 110.323Z",
    fill: "url(#paint55_radial_3654_4710)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.67 131.031L66.2189 109.979L54.9117 110.385L107.98 141.026L102.67 131.031Z",
    fill: "url(#paint56_radial_3654_4710)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2192 109.979L102.671 131.032L107.981 127.159L66.9376 103.451L66.2192 109.979Z",
    fill: "url(#paint57_radial_3654_4710)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9117 110.385L66.2189 109.979L66.9372 103.451L54.9117 110.385Z",
    fill: "url(#paint58_radial_3654_4710)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.981 141.027L102.671 131.031L107.981 127.158V141.027Z",
    fill: "url(#paint59_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8792 110.323L66.281 110.76L81.5862 118.85L66.9994 109.886L66.7183 105.263L65.8437 109.573L56.8792 110.323Z",
    fill: "url(#paint60_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.045 139.28L101.954 131.346L94.0198 126.036L102.391 130.315L106.514 128.223L103.234 131.159L107.045 139.28Z",
    fill: "url(#paint61_radial_3654_4710)"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.551 97.0175V54.9437L167.548 45.3545V106.607L161.551 97.0175Z",
    fill: "url(#paint62_radial_3654_4710)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.551 54.9431V97.0169L155.554 99.7031V52.2881L161.551 54.9431Z",
    fill: "url(#paint63_radial_3654_4710)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.548 45.3545L161.551 54.9437L155.554 52.2887L167.548 45.3545Z",
    fill: "url(#paint64_radial_3654_4710)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.548 106.608L161.551 97.0186L155.554 99.7048L167.548 106.608Z",
    fill: "url(#paint65_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.515 47.042L162.205 55.413L161.549 72.6549L161.08 55.5692L157.207 53.0392L161.393 54.4135L166.515 47.042Z",
    fill: "url(#paint66_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.515 104.951L162.205 96.5795L161.549 87.0527L161.08 96.4233L157.207 98.9534L161.393 97.579L166.515 104.951Z",
    fill: "url(#paint67_radial_3654_4710)"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.67 20.9611L66.2189 41.9824L54.9117 41.5763L107.98 10.9658L102.67 20.9611Z",
    fill: "url(#paint68_radial_3654_4710)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2192 41.9803L102.671 20.959L107.981 24.8009L66.9376 48.5084L66.2192 41.9803Z",
    fill: "url(#paint69_radial_3654_4710)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9117 41.5752L66.2189 41.9813L66.9372 48.5094L54.9117 41.5752Z",
    fill: "url(#paint70_radial_3654_4710)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.981 10.9658L102.671 20.9611L107.981 24.803V10.9658Z",
    fill: "url(#paint71_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8792 41.6688L66.281 41.2003L81.5862 33.1416L66.9994 42.1061L66.7183 46.6977L65.8437 42.4185L56.8792 41.6688Z",
    fill: "url(#paint72_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.045 12.7139L101.954 20.6164L94.0198 25.9576L102.391 21.6784L106.514 23.7399L103.234 20.835L107.045 12.7139Z",
    fill: "url(#paint73_radial_3654_4710)"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.083 41.9824L117.632 20.9611L112.322 10.9658L165.39 41.5763L154.083 41.9824Z",
    fill: "url(#paint74_radial_3654_4710)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.632 20.959L154.083 41.9803L153.396 48.5084L112.322 24.8009L117.632 20.959Z",
    fill: "url(#paint75_radial_3654_4710)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.322 10.9658L117.632 20.9611L112.322 24.803V10.9658Z",
    fill: "url(#paint76_radial_3654_4710)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.392 41.5752L154.085 41.9813L153.367 48.5094L165.392 41.5752Z",
    fill: "url(#paint77_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.261 12.7139L118.352 20.6164L132.971 29.7995L117.915 21.6784L113.792 23.7399L117.072 20.835L113.261 12.7139Z",
    fill: "url(#paint78_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.424 41.6667L154.023 41.1982L145.433 36.9814L153.304 42.104L153.585 46.6956L154.46 42.4164L163.424 41.6667Z",
    fill: "url(#paint79_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.871 28.9235C78.3078 29.2359 79.5884 32.5781 78.9949 34.6083L92.3949 26.862C91.7832 25.838 91.4448 24.6741 91.412 23.4818C91.3792 22.2896 91.653 21.1088 92.2074 20.0527L76.871 28.9235Z",
    fill: "url(#paint80_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.524 118.789C149.181 119.132 144.808 117.539 144.277 115.665L132.438 122.474C134.438 122.818 137.186 125.41 136.78 126.91L150.524 118.789Z",
    fill: "url(#paint81_radial_3654_4710)"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 28.582L151.21 52.2895V99.7046L110.136 123.381L69.0927 99.7046V52.2895L110.136 28.582Z",
    fill: "#0068FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9596 62.0349L94.643 59.4424L103.576 54.2886L110.136 48.0728V28.582L89.6142 40.4514L69.0927 52.2895L85.9596 62.0349Z",
    fill: "url(#paint82_radial_3654_4710)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.138 48.0728L116.728 54.2886L125.662 59.4424L134.314 62.0349L151.212 52.2895L130.69 40.4514L110.138 28.582V48.0728Z",
    fill: "url(#paint83_radial_3654_4710)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.312 62.0335L132.219 70.8418V81.1494L134.312 89.9577L151.21 99.7031V75.9956V52.2881L134.312 62.0335Z",
    fill: "url(#paint84_radial_3654_4710)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.314 89.957L125.662 92.5495L116.728 97.7034L110.138 103.888V123.379L130.69 111.541L151.212 99.7024L134.314 89.957Z",
    fill: "url(#paint85_radial_3654_4710)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 103.888L103.576 97.7034L94.643 92.5495L85.9596 89.957L69.0927 99.7024L89.6142 111.541L110.136 123.379V103.888Z",
    fill: "url(#paint86_radial_3654_4710)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.9596 89.9577L88.0524 81.1494V70.8418L85.9596 62.0335L69.0927 52.2881V75.9956V99.7031L85.9596 89.9577Z",
    fill: "url(#paint87_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.907 74.2152C135.907 69.9672 150.806 55.4741 151.212 66.8437V52.2881L138.343 59.7221L135.907 69.9672V74.2152Z",
    fill: "url(#paint88_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6782 41.5753C91.1766 41.5753 94.0815 52.0703 93.5505 55.8498L102.484 50.696C100.266 48.447 98.8604 35.0783 105.264 31.4238L87.6782 41.5753Z",
    fill: "url(#paint89_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.278 103.17C139.843 102.795 136.438 102.233 131.503 94.3613L128.223 95.3609L121.57 99.2028C125.037 101.608 131.659 108.573 129.66 112.197L145.278 103.17Z",
    fill: "url(#paint90_radial_3654_4710)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.821 50.6953L128.253 56.6925L135.906 69.9674V81.993L128.253 95.2992L117.821 101.296H102.484L92.0518 95.2992L84.3992 81.993V69.9674L92.0518 56.6925L102.484 50.6953H117.821Z",
    fill: "url(#paint91_radial_3654_4710)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.484 50.6958L110.137 43.4492L117.821 50.6958H102.484Z",
    fill: "url(#paint92_radial_3654_4710)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.253 56.6934L138.342 59.7232L135.906 69.9683L128.253 56.6934Z",
    fill: "url(#paint93_radial_3654_4710)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.906 81.9922L138.342 92.2686L128.253 95.2984L135.906 81.9922Z",
    fill: "url(#paint94_radial_3654_4710)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.484 101.298L110.137 108.544L117.821 101.298H102.484Z",
    fill: "url(#paint95_radial_3654_4710)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3983 81.9922L81.9619 92.2686L92.0509 95.2984L84.3983 81.9922Z",
    fill: "url(#paint96_radial_3654_4710)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0509 56.6934L81.9619 59.7232L84.3983 69.9683L92.0509 56.6934Z",
    fill: "url(#paint97_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2411 88.6462L110.137 75.996L88.2411 63.3457L84.3992 69.9676V81.9931L88.2411 88.6462Z",
    fill: "url(#paint98_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2395 63.3456L110.135 75.9958V50.6953H102.483L92.0502 56.6925L88.2395 63.3456Z",
    fill: "url(#paint99_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.138 50.6953V75.9958L132.065 63.3456L128.254 56.6925L117.822 50.6953H110.138Z",
    fill: "url(#paint100_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.065 63.3457L110.138 75.996L132.065 88.6462L135.907 81.9931V69.9676L132.065 63.3457Z",
    fill: "url(#paint101_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.065 88.6454L110.138 75.9951V101.296H117.822L128.254 95.2985L132.065 88.6454Z",
    fill: "url(#paint102_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.135 101.296V75.9951L88.2395 88.6454L92.0502 95.2985L102.483 101.296H110.135Z",
    fill: "url(#paint103_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.424 98.2988L102.64 101.797C104.951 103.972 107.044 106.367 108.887 108.95C109.78 112.972 110.251 117.075 110.293 121.194C110.352 117.059 110.801 112.938 111.636 108.888C111.819 108.425 112.072 107.993 112.386 107.607L115.103 104.015L111.98 105.889C111.497 106.196 110.924 106.328 110.355 106.264C108.172 105.505 106.325 104.001 105.139 102.016L108.731 101.297L103.421 100.891L97.424 98.2988Z",
    fill: "url(#paint104_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4244 53.6938L102.485 50.0705C104.788 47.889 106.88 45.494 108.732 42.9177C109.619 38.642 110.09 34.2904 110.137 29.9238C110.197 34.2968 110.647 38.6557 111.48 42.9489C111.663 43.4213 111.916 43.8635 112.23 44.2608L114.947 47.8528L111.824 45.9475C111.346 45.6303 110.769 45.4972 110.2 45.5727C109.074 45.929 108.034 46.5119 107.142 47.2854C106.25 48.0589 105.526 49.0068 105.015 50.0705L108.607 50.7889L103.297 51.195L97.2683 53.7875L97.4244 53.6938Z",
    fill: "url(#paint105_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4249 53.6932L91.8026 56.4419C88.7483 57.3669 85.6092 57.9843 82.432 58.2848C78.4962 57.0384 74.6972 55.3953 71.0936 53.3809C74.6622 55.4905 78.0197 57.9381 81.1201 60.6899C82.139 62.4101 82.9764 64.2315 83.6189 66.1248C83.6189 64.7192 83.2128 62.033 84.025 60.9085C85.7255 59.3413 87.9595 58.4812 90.272 58.5034L89.085 62.0018L92.2086 57.5976L97.4249 53.6932Z",
    fill: "url(#paint106_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.904 75.9951L136.311 82.2422C137.053 85.3364 138.099 88.3496 139.434 91.2379C142.181 93.8888 145.232 96.2058 148.523 98.1409C145.203 96.2488 141.683 94.7298 138.028 93.6118C137.542 93.5336 137.047 93.5336 136.56 93.6118L132.094 94.174L135.217 92.4561C135.728 92.1914 136.136 91.7623 136.373 91.2379C136.812 88.9608 136.424 86.6018 135.28 84.5848L132.875 87.3335L135.155 82.5233L135.936 76.0264L135.904 75.9951Z",
    fill: "url(#paint107_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7363 97.3911C92.0506 95.2984 71.9976 100.921 81.7117 106.98L69.2177 99.7025L82.0865 92.2686L92.1755 95.3921L95.8613 97.4848L95.7363 97.3911Z",
    fill: "url(#paint108_radial_3654_4710)"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1259 51.1637L110.137 26.3317V23.5518L64.7521 49.7893L67.1259 51.1637Z",
    fill: "url(#paint109_radial_3654_4710)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 26.333L67.1252 51.165L69.0931 52.2895L110.136 28.5819V26.333Z",
    fill: "url(#paint110_radial_3654_4710)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.138 26.3317L153.18 51.1637L155.554 49.7893L110.138 23.5518V26.3317Z",
    fill: "url(#paint111_radial_3654_4710)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.18 51.165L110.138 26.333V28.5819L151.212 52.2895L153.18 51.165Z",
    fill: "url(#paint112_radial_3654_4710)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0931 99.7026V52.2876L67.1252 51.1631V100.827L69.0931 99.7026Z",
    fill: "url(#paint113_radial_3654_4710)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1259 100.828V51.1644L64.7521 49.79V102.203L67.1259 100.828Z",
    fill: "url(#paint114_radial_3654_4710)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.21 52.2876V99.7026L153.178 100.827V51.1631L151.21 52.2876Z",
    fill: "url(#paint115_radial_3654_4710)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.178 51.1644V100.828L155.551 102.203V49.79L153.178 51.1644Z",
    fill: "url(#paint116_radial_3654_4710)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.136 123.378L69.0931 99.7021L67.1252 100.827L110.136 125.659V123.378Z",
    fill: "url(#paint117_radial_3654_4710)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.137 125.66L67.1259 100.828L64.7521 102.202L110.137 128.409V125.66Z",
    fill: "url(#paint118_radial_3654_4710)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.212 99.7021L110.138 123.378V125.659L153.18 100.827L151.212 99.7021Z",
    fill: "url(#paint119_radial_3654_4710)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.18 100.828L110.138 125.66V128.409L155.554 102.202L153.18 100.828Z",
    fill: "url(#paint120_radial_3654_4710)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.981 10.9645L110.136 6.0918V26.3322L107.981 24.8017V10.9645Z",
    fill: "url(#paint121_radial_3654_4710)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.324 10.9645L110.138 6.0918V26.3322L112.324 24.8017V10.9645Z",
    fill: "url(#paint122_radial_3654_4710)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.391 41.5759L170.701 41.0449L153.178 51.1651L153.365 48.5101L165.391 41.5759Z",
    fill: "url(#paint123_radial_3654_4710)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.546 45.3554L170.701 41.0449L153.178 51.1651L155.551 52.2896L167.546 45.3554Z",
    fill: "url(#paint124_radial_3654_4710)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.546 106.605L170.701 110.947L153.178 100.827L155.551 99.7021L167.546 106.605Z",
    fill: "url(#paint125_radial_3654_4710)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.391 110.386L170.701 110.948L153.178 100.828L153.365 103.452L165.391 110.386Z",
    fill: "url(#paint126_radial_3654_4710)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.981 141.029L110.136 145.902V125.661L107.981 127.16V141.029Z",
    fill: "url(#paint127_radial_3654_4710)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.324 141.029L110.138 145.902V125.661L112.324 127.16V141.029Z",
    fill: "url(#paint128_radial_3654_4710)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.759 106.605L49.6042 110.947L67.1584 100.827L64.7533 99.7021L52.759 106.605Z",
    fill: "url(#paint129_radial_3654_4710)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9143 110.386L49.6042 110.948L67.1584 100.828L66.9397 103.452L54.9143 110.386Z",
    fill: "url(#paint130_radial_3654_4710)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9143 41.5759L49.6042 41.0449L67.1584 51.1651L66.9397 48.5101L54.9143 41.5759Z",
    fill: "url(#paint131_radial_3654_4710)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.759 45.3554L49.6042 41.0449L67.1584 51.1651L64.7533 52.2896L52.759 45.3554Z",
    fill: "url(#paint132_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7759 42.699L109.263 25.707L110.137 11.3076L111.012 25.7383L123.787 34.203L110.137 27.1439L81.7759 42.699Z",
    fill: "url(#paint133_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.18 68.0615L154.149 100.359L166.174 108.324L153.243 101.858L139.531 108.699L152.462 100.421L153.18 68.0615Z",
    fill: "url(#paint134_radial_3654_4710)"
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 75.9951L52.759 83.0855L58.7561 75.9951H49.6042Z",
    fill: "url(#paint135_radial_3654_4710)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 75.9947L52.759 68.873L58.7561 75.9947H49.6042Z",
    fill: "url(#paint136_radial_3654_4710)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.703 75.9951L167.548 83.0855L161.551 75.9951H170.703Z",
    fill: "url(#paint137_radial_3654_4710)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.703 75.9947L167.548 68.873L161.551 75.9947H170.703Z",
    fill: "url(#paint138_radial_3654_4710)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8695 23.5533L75.3092 29.8316L84.4611 31.4871L87.6158 22.71L79.8695 23.5533Z",
    fill: "#868686"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8695 23.5518L75.3092 29.83L84.4611 31.4855L79.8695 23.5518Z",
    fill: "url(#paint139_radial_3654_4710)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8694 23.5533L87.6157 22.71L84.461 31.4871L79.8694 23.5533Z",
    fill: "url(#paint140_radial_3654_4710)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.435 128.408L132.689 129.252L135.843 120.506L145.026 122.161L140.435 128.408Z",
    fill: "#868686"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.435 128.408L132.689 129.252L135.843 120.506L140.435 128.408Z",
    fill: "url(#paint141_radial_3654_4710)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.434 128.408L145.026 122.161L135.843 120.506L140.434 128.408Z",
    fill: "url(#paint142_radial_3654_4710)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.435 23.5533L132.689 22.71L135.843 31.4871L145.026 29.8316L140.435 23.5533Z",
    fill: "#868686"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.435 23.5533L132.689 22.71L135.843 31.4871L140.435 23.5533Z",
    fill: "url(#paint143_radial_3654_4710)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.434 23.5518L145.026 29.83L135.843 31.4855L140.434 23.5518Z",
    fill: "url(#paint144_radial_3654_4710)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8695 128.408L75.3092 122.161L84.4611 120.506L87.6158 129.252L79.8695 128.408Z",
    fill: "#868686"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8695 128.408L75.3092 122.161L84.4611 120.506L79.8695 128.408Z",
    fill: "url(#paint145_radial_3654_4710)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8694 128.408L87.6157 129.252L84.461 120.506L79.8694 128.408Z",
    fill: "url(#paint146_radial_3654_4710)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.871 128.41L67.4393 127.191L70.5004 144.652L87.18 138.561L79.871 128.41Z",
    fill: "#F56D00"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8444 120.32L57.1297 121.226L56.7236 129.41L67.0625 126.973L65.8444 120.32Z",
    fill: "#F56D00"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9251 136.529L97.4859 144.526L90.6142 148.961L87.5531 138.778L93.9251 136.529Z",
    fill: "#F56D00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.434 128.41L133.125 138.561L149.773 144.652L152.865 127.191L140.434 128.41Z",
    fill: "#F56D00"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.379 136.529L122.818 144.526L129.689 148.961L132.751 138.778L126.379 136.529Z",
    fill: "#F56D00"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.46 120.32L163.174 121.226L163.58 129.41L153.242 126.973L154.46 120.32Z",
    fill: "#F56D00"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.871 128.41L67.4393 127.191L70.5004 144.652L79.871 128.41Z",
    fill: "url(#paint147_radial_3654_4710)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8693 128.409L87.1784 138.561L70.4988 144.651L79.8693 128.409Z",
    fill: "url(#paint148_radial_3654_4710)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7236 129.41L65.8444 120.32L57.1297 121.226L56.7236 129.41Z",
    fill: "url(#paint149_radial_3654_4710)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7236 129.41L67.0625 126.973L65.8444 120.32L56.7236 129.41Z",
    fill: "url(#paint150_radial_3654_4710)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6156 148.961L93.9265 136.529L97.4873 144.526L90.6156 148.961Z",
    fill: "url(#paint151_radial_3654_4710)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6142 148.961L87.5531 138.778L93.9251 136.529L90.6142 148.961Z",
    fill: "url(#paint152_radial_3654_4710)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.434 128.409L133.125 138.561L149.773 144.651L140.434 128.409Z",
    fill: "url(#paint153_radial_3654_4710)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.433 128.41L152.865 127.191L149.773 144.652L140.433 128.41Z",
    fill: "url(#paint154_radial_3654_4710)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.689 148.961L126.379 136.529L122.818 144.526L129.689 148.961Z",
    fill: "url(#paint155_radial_3654_4710)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.688 148.961L132.75 138.778L126.378 136.529L129.688 148.961Z",
    fill: "url(#paint156_radial_3654_4710)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.579 129.41L154.459 120.32L163.173 121.226L163.579 129.41Z",
    fill: "url(#paint157_radial_3654_4710)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.58 129.41L153.242 126.973L154.46 120.32L163.58 129.41Z",
    fill: "url(#paint158_radial_3654_4710)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.871 23.5529L87.18 13.4014L70.5004 7.3418L67.4393 24.8023L79.871 23.5529Z",
    fill: "#F56D00"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8693 23.5529L87.1784 13.4014L70.4988 7.3418L79.8693 23.5529Z",
    fill: "url(#paint159_radial_3654_4710)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.871 23.5529L67.4393 24.8023L70.5004 7.3418L79.871 23.5529Z",
    fill: "url(#paint160_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9957 15.1194C74.4656 12.808 72.6227 10.1842 73.3724 8.37256L70.4988 7.3418L75.4964 15.9627L79.8693 23.5529L82.9929 19.3049C81.8684 19.5235 78.9948 16.8998 77.0582 15.1194H76.9957Z",
    fill: "url(#paint161_radial_3654_4710)"
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9251 15.4638L97.4859 7.46763L90.6142 3.03223L87.5531 13.1837L93.9251 15.4638Z",
    fill: "#F56D00"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6156 3.03223L93.9265 15.4638L97.4873 7.46763L90.6156 3.03223Z",
    fill: "url(#paint162_radial_3654_4710)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6142 3.03223L87.5531 13.1837L93.9251 15.4638L90.6142 3.03223Z",
    fill: "url(#paint163_radial_3654_4710)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8444 31.6744L57.1297 30.7686L56.7236 22.585L67.0625 25.0213L65.8444 31.6744Z",
    fill: "#F56D00"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7236 22.585L65.8444 31.6744L57.1297 30.7686L56.7236 22.585Z",
    fill: "url(#paint164_radial_3654_4710)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7236 22.585L67.0625 25.0213L65.8444 31.6744L56.7236 22.585Z",
    fill: "url(#paint165_radial_3654_4710)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.702 75.9975L175.824 64.5967L189.443 75.9975L175.824 87.3671L170.702 75.9975Z",
    fill: "#F56D00"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.702 75.9975L175.824 64.5967L189.443 75.9975H170.702Z",
    fill: "url(#paint166_radial_3654_4710)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.702 75.9951L175.824 87.3647L189.443 75.9951H170.702Z",
    fill: "url(#paint167_radial_3654_4710)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.702 59.7535L175.824 52.6943L183.102 56.4426L175.824 64.1577L170.702 59.7535Z",
    fill: "#F56D00"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.102 56.4426L170.702 59.7535L175.824 52.6943L183.102 56.4426Z",
    fill: "url(#paint168_radial_3654_4710)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.102 56.4434L175.824 64.1584L170.702 59.7543L183.102 56.4434Z",
    fill: "url(#paint169_radial_3654_4710)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.702 92.2079L175.824 99.2983L183.102 95.55L175.824 87.8037L170.702 92.2079Z",
    fill: "#F56D00"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.102 95.5502L170.702 92.208L175.824 99.2984L183.102 95.5502Z",
    fill: "url(#paint170_radial_3654_4710)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.102 95.55L175.824 87.8037L170.702 92.2079L183.102 95.55Z",
    fill: "url(#paint171_radial_3654_4710)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.434 23.5529L133.125 13.4014L149.773 7.3418L152.865 24.8023L140.434 23.5529Z",
    fill: "#F56D00"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.434 23.5529L133.125 13.4014L149.773 7.3418L140.434 23.5529Z",
    fill: "url(#paint172_radial_3654_4710)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.433 23.5529L152.865 24.8023L149.773 7.3418L140.433 23.5529Z",
    fill: "url(#paint173_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.307 15.1194C145.806 12.808 147.68 10.1842 146.93 8.37256L149.804 7.3418L144.806 15.9627L140.433 23.5529L137.31 19.3049C138.403 19.5235 141.308 16.8998 143.245 15.1194H143.307Z",
    fill: "url(#paint174_radial_3654_4710)"
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.379 15.4638L122.818 7.46763L129.689 3.03223L132.751 13.1837L126.379 15.4638Z",
    fill: "#F56D00"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.689 3.03223L126.379 15.4638L122.818 7.46763L129.689 3.03223Z",
    fill: "url(#paint175_radial_3654_4710)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.688 3.03223L132.75 13.1837L126.378 15.4638L129.688 3.03223Z",
    fill: "url(#paint176_radial_3654_4710)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.46 31.6744L163.174 30.7686L163.58 22.585L153.242 25.0213L154.46 31.6744Z",
    fill: "#F56D00"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.579 22.585L154.459 31.6744L163.173 30.7686L163.579 22.585Z",
    fill: "url(#paint177_radial_3654_4710)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.58 22.585L153.242 25.0213L154.46 31.6744L163.58 22.585Z",
    fill: "url(#paint178_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.165 71.5908C185.134 74.4332 181.042 75.6826 176.763 75.995H189.444L184.165 71.5908Z",
    fill: "url(#paint179_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9924 22.3335L93.2996 15.4618L91.5817 6.71594L94.2367 14.8996L109.448 5.65395L110.135 0.78125L110.823 5.65395L119.225 11.3075L110.135 6.93459L81.9924 22.3335Z",
    fill: "url(#paint180_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7784 127.223L66.0652 120.757L61.4736 124.661L65.0969 120.257L49.6043 111.761L45.0439 113.604L48.9171 110.574L49.6043 92.208L50.3539 110.512L77.7784 127.223Z",
    fill: "url(#paint181_radial_3654_4710)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.184 127.971L154.271 120.787L159.706 125.566L155.115 120.288L170.701 111.76L175.261 113.603L171.388 110.573L170.701 92.4883L169.951 110.511L141.184 127.971Z",
    fill: "url(#paint182_radial_3654_4710)"
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 75.9975L44.4815 64.5967L30.863 75.9975L44.4815 87.3671L49.6042 75.9975Z",
    fill: "#F56D00"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 75.9975L44.4815 64.5967L30.863 75.9975H49.6042Z",
    fill: "url(#paint183_radial_3654_4710)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6042 75.9951L44.4815 87.3647L30.863 75.9951H49.6042Z",
    fill: "url(#paint184_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8271 74.2769C37.7036 75.2764 34.3926 75.5887 33.2057 74.027L30.863 75.9948H49.6042L47.4489 71.2158C47.0741 72.2778 43.3571 73.496 40.8271 74.3393V74.2769Z",
    fill: "url(#paint185_radial_3654_4710)"
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6028 59.7535L44.4802 52.6943L37.1711 56.4426L44.4802 64.1577L49.6028 59.7535Z",
    fill: "#F56D00"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1711 56.4426L49.6028 59.7535L44.4802 52.6943L37.1711 56.4426Z",
    fill: "url(#paint186_radial_3654_4710)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1711 56.4434L44.4802 64.1584L49.6028 59.7543L37.1711 56.4434Z",
    fill: "url(#paint187_radial_3654_4710)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6028 92.2079L44.4802 99.2983L37.1711 95.55L44.4802 87.8037L49.6028 92.2079Z",
    fill: "#F56D00"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1711 95.5502L49.6028 92.208L44.4802 99.2984L37.1711 95.5502Z",
    fill: "url(#paint188_radial_3654_4710)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1711 95.55L44.4802 87.8037L49.6028 92.2079L37.1711 95.55Z",
    fill: "url(#paint189_radial_3654_4710)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7776 24.7715L49.6035 40.2329L45.0432 38.39L48.9163 41.4198L49.3535 59.1302L42.6068 57.8808L49.3535 60.161L49.6035 70.4061L50.3531 41.4511L77.7776 24.7715Z",
    fill: "url(#paint190_radial_3654_4710)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3654_4710",
    transform: "scale(0.04)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_3654_4710",
    transform: "scale(0.0833333 0.030303)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_3654_4710",
    transform: "scale(0.04)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_3654_4710",
    transform: "scale(0.0192308 0.111111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_3654_4710",
    transform: "scale(0.030303 0.0769231)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_3654_4710",
    transform: "scale(0.0555556 0.025)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_3654_4710",
    transform: "scale(0.0714286 0.04)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_3654_4710",
    transform: "scale(0.0555556 0.025)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_3654_4710",
    transform: "scale(0.0714286 0.04)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_3654_4710",
    transform: "scale(0.025 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image10_3654_4710",
    transform: "scale(0.0384615 0.0714286)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11_3654_4710",
    transform: "scale(0.025 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12_3654_4710",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image12_3654_4710",
    transform: "scale(0.0384615 0.0714286)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.542 200.281) scale(77.8069 77.8069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0097FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#176FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#176DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1866EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#195BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1A4CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#1C3997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2E82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3654_4710",
    x1: 64.5325,
    y1: 179.322,
    x2: 155.77,
    y2: 179.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FCD95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F8C147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F6B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F5AD37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F9C449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FDE160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7B941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.544 175.17) scale(43.698 43.6981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0097FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3654_4710",
    x1: 81.6202,
    y1: 164.425,
    x2: 138.687,
    y2: 164.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F39E2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FCD95A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F8C147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F6B23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F5AD37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F9C449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FDE160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7B941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2306 54.4758) scale(53.4434 53.4435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4833 68.5307) scale(43.2295 43.2295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2364 46.8212) scale(51.1633 51.1633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0523 59.1591) scale(51.0696 51.0696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D95E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3312 17.0858) scale(74.371 74.371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7094 28.8625) scale(59.3782 59.3781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8632 17.5556) scale(60.7837 60.7837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0235 27.6113) scale(56.0984 56.0984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0224 15.3681) scale(61.2835 61.2835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8334 26.8314) scale(45.2286 45.2286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4927 27.7672) scale(28.6115 28.6114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4019 42.2309) scale(28.2991 28.2991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.588 52.2273) scale(27.4558 27.4557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.106 54.4758) rotate(180) scale(53.4434 53.4435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.854 68.5307) rotate(180) scale(43.2295 43.2295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.098 46.8212) rotate(180) scale(51.1633 51.1633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.252 59.1591) rotate(180) scale(51.0696 51.0696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D95E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.006 17.0858) rotate(180) scale(74.371 74.371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C74900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.625 28.8625) rotate(180) scale(59.3782 59.3781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.441 17.5556) rotate(180) scale(60.7837 60.7837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.31 27.6113) rotate(180) scale(56.0984 56.0984)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.313 15.3681) rotate(180) scale(61.2834 61.2835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(198.501 26.8314) rotate(180) scale(45.2286 45.2286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.812 27.7672) rotate(180) scale(28.6115 28.6114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.903 42.2309) rotate(180) scale(28.2991 28.2991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.75 52.2273) rotate(180) scale(27.4557 27.4557)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.636 -1.6876) scale(80.6181 80.6181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.401 -26.2072) scale(97.0478 97.0478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.514 38.6076) scale(66.4998 66.4997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.593 -13.2116) scale(146.149 146.15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-29.2672 65.0019) scale(115.634 115.633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.6206 74.7477) scale(98.3606 98.3597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.942 78.1836) scale(103.73 103.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.504 63.6275) scale(108.106 108.105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.762 88.8036) scale(89.239 89.239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.51 87.2105) scale(109.698 109.698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.58 133.782) scale(77.7444 77.7444)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.387 80.0888) scale(89.7387 89.7388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.5318 -3.2797) scale(61.0336 61.0336)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.442 108.263) scale(51.257 51.257)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.38 53.4132) scale(61.2517 61.2522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.6908 51.882) scale(66.6564 66.6559)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7553 56.6616) scale(31.7037 31.7037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.7322 71.4369) scale(36.4202 36.4202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4428 53.2578) scale(26.8935 26.8935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.0074 95.2364) scale(25.1443 25.1443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.785 66.9989) scale(77.3697 77.3696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.837 102.889) scale(75.6518 75.6517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.785 123.004) scale(35.421 35.4207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.273 109.417) scale(24.2073 24.2073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.07 134.344) scale(27.1434 27.1434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.244 108.605) scale(28.8301 28.8301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.576 129.532) scale(63.0951 63.0951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.109 130.813) scale(45.1036 45.1036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.1549 110.167) scale(33.4527 33.4529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8011 121.099) scale(30.7357 30.7355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.6865 109.761) scale(25.8315 25.8315)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.86 125.193) scale(21.8333 21.8334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.526 48.4468) scale(58.379 58.3786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.3 55.5365) scale(59.6597 59.6592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.269 57.2239) scale(15.0555 15.0554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.768 81.7445) scale(30.6107 30.6105)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.143 51.1026) scale(22.8328 22.8329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.862 93.7058) scale(21.9582 21.9583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.826 26.4897) scale(95.0487 95.0487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.014 26.7063) scale(84.7411 84.7411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0939 41.419) scale(61.002 61.0024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.728 2.40738) scale(40.1063 40.106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.6558 42.356) scale(29.6422 29.6422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.672 20.8975) scale(22.3643 22.3644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.631 18.7434) scale(85.0848 85.0847)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.851 20.6779) scale(47.259 47.2589)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.257 17.3066) scale(50.1641 50.1637)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.305 23.4588) scale(26.425 26.425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.821 21.1161) scale(34.4212 34.4212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.835 38.8243) scale(23.6763 23.6763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.2699 30.3916) scale(47.5088 47.5087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.591 105.763) scale(25.1131 25.1131)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.544 48.4789) scale(65.4066 65.4065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.125 61.6601) scale(60.5963 60.5963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.785 55.9114) scale(49.9762 49.9763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.535 64.5003) scale(89.8949 89.8949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.571 109.542) scale(61.5022 61.5021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.7978 52.7566) scale(54.7241 54.7241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.459 82.7424) scale(31.6725 31.6725)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.952 53.1948) scale(65.6877 65.6876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.255 90.8005) scale(27.5182 27.5182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.642 51.8823) scale(65.7502 65.7501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.735 32.5169) scale(40.0436 40.0435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.964 41.7317) scale(32.4535 32.4534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.436 91.7063) scale(39.7313 39.7312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.947 94.5823) scale(38.4193 38.4193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.1801 94.3926) scale(44.2604 44.2603)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.6136 57.2244) scale(58.9723 58.9721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4265 89.5833) scale(84.5227 84.5224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.4875 4.24857) scale(79.2751 79.2749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(136.594 33.8908) scale(50.1324 50.1325)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.432 45.0106) scale(56.5982 56.5982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.842 122.598) scale(84.5536 84.5537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.1117 114.945) scale(55.2864 55.2863)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.168 103.827) scale(31.3289 31.3289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.671 42.7303) scale(28.2677 28.2679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.7117 55.0051) scale(26.8623 26.8623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.747 92.05) scale(34.4211 34.4212)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.7671 126.565) scale(41.1368 41.1368)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.825 37.3577) scale(55.0052 55.0052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.787 76.5905) scale(78.7128 78.7127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.848 12.1197) scale(68.3113 68.3114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.995 18.8053) scale(62.5016 62.5016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.549 70.9662) scale(89.3334 89.3327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4745 61.9405) scale(72.2138 72.2158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.278 69.5294) scale(68.593 68.5925)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.66 70.1242) scale(63.6556 63.6573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.884 73.3709) scale(75.3394 75.3393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.26 78.0577) scale(77.1197 77.1197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.124 111.665) scale(65.5939 65.5939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.791 87.6469) scale(65.9062 65.9063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.636 26.5196) scale(21.3962 21.3961)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.4873 16.7742) scale(25.5185 25.5192)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.14 30.0189) scale(39.9185 39.9186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.928 56.2252) scale(27.2995 27.2996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.334 100.452) scale(33.6715 33.6716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.614 101.14) scale(22.5205 22.5206)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.074 126.598) scale(20.5216 20.5215)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.231 126.754) scale(19.6152 19.6157)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.1277 99.8583) scale(21.1462 21.1462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.4078 100.734) scale(27.5807 27.5807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.5635 49.2598) scale(41.1367 41.1367)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.156 45.6677) scale(33.3592 33.3592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.389 23.9891) scale(52.1941 52.194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.992 101.14) scale(50.0388 50.0388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.6298 59.4717) scale(25.5816 25.5816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0065 77.4003) scale(26.6123 26.6124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.677 59.4717) rotate(180) scale(25.5816 25.5816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.3 77.4003) rotate(180) scale(26.6123 26.6124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.3304 14.1187) scale(26.3312 26.3313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.6248 39.9206) scale(26.7996 26.7998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.839 116.477) scale(42.3858 42.3862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.59 128.877) scale(29.8296 29.8297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.555 37.984) scale(26.7371 26.7373)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.222 7.24699) scale(29.6422 29.6422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.4337 115.102) scale(31.2351 31.2352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.2793 107.106) scale(33.5151 33.5154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.401 144.964) scale(27.7682 27.7681)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.0639 113.791) scale(33.3592 33.3592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.2831 135.313) scale(20.9589 20.9588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9129 110.044) scale(22.6455 22.6455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.9664 125.722) scale(28.6424 28.6427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6123 150.335) scale(14.8055 14.8055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.05 116.259) scale(37.7635 37.7633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.83 151.774) scale(30.1733 30.1732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.148 127.252) scale(37.7006 37.7009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.684 153.834) scale(20.9589 20.9588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.394 136.125) scale(21.2711 21.2712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.884 110.325) scale(35.7643 35.7643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.4027 6.99821) scale(38.6067 38.6067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.092 7.18562) scale(35.5145 35.5144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.7155 6.12362) scale(35.3583 35.3583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.2067 3.65693) scale(26.1749 26.1751)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6123 1.22059) scale(28.6428 28.6427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.877 17.9309) scale(30.1421 30.142)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.1884 13.2144) scale(28.4865 28.4865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.943 77.9029) scale(32.672 32.672)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.523 31.0477) scale(60.5338 60.5338)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.069 59.9721) scale(18.8973 18.8973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.453 32.6109) scale(32.141 32.141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(183.945 70.6557) scale(29.1112 29.1112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(187.1 96.7057) scale(25.7066 25.7066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.9 0.813639) scale(29.2675 29.2674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.281 3.03134) scale(36.5765 36.5764)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.867 5.24904) scale(26.2688 26.2688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.409 0.502175) scale(22.7078 22.708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.944 -2.65258) scale(28.3929 28.3928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.835 14.7762) scale(24.4883 24.4884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.269 15.9319) scale(22.4893 22.4893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.286 77.9316) scale(19.9593 19.9593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.636 6.40359) scale(50.6636 50.6635)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9777 108.357) scale(50.5072 50.5073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.198 109.855) scale(59.6905 59.6905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.8545 77.1845) scale(34.7336 34.7335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9473 40.387) scale(47.5712 47.5712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.643 77.9001) scale(21.2087 21.2087)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9786 62.346) scale(28.3616 28.3615)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5701 35.4533) scale(30.8605 30.8604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.235 69.3751) scale(31.4227 31.4226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0396 103.734) scale(30.8917 30.8916)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_3654_4710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.0095 40.7014) scale(47.1651 47.1652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3654_4710",
    width: 25,
    height: 25,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAq0lEQVRIS7WWSQoDMQwEy0MeEPL/N4b5gXKJwBgv2qaOxnTREhg3EaGK95dp2Gt26GUVrqQkp3DlOl1YYRVAUOIRgHNc3nDF3CQqAEOTTDjA/aGZm2TYSipawEZSJYCFJCsYeWQnfQuYSLItRgEMkicE0Emygh1lO1m1gL8k22InAMOzsuMUroTHZRUAXJFReQQQaOIVADQRMS0+Eq4cF58JV5r+u/o2FcE9Pzr2PCoNJVMWAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_3654_4710",
    width: 12,
    height: 33,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAhCAYAAADtR0oPAAAACXBIWXMAAAsSAAALEgHS3X78AAAAeElEQVQ4T+2VQQ4AEQxFHycQ9z+juIFZocTQbiaRzNu1PB8LXCkFSUgMjRxxsva7yateE1aTVwwJb8jF/Nw4oUqAvqhaqHwgWA4MxoSQKCYBjAnwCzpuF3LE+fkZOWFKgLuFejleFhpawk6SY+otVdz8P0B/FlepDz5dIjW9LmIUAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_3654_4710",
    width: 25,
    height: 25,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsSAAALEgHS3X78AAAAq0lEQVRIS7WVQQ6EIBAEe/yAZv//Rcn+YDy5IgtDzwB11MSi2hhFVXEkKCp8P5DadS+bdfNI0NYBPMh+Kv2QaJlZUhKtckmAmEisF9+Dnc9dksMebkgCcKIN4LNb9ES/kpWi11yrRMPvhOFPsqKmWjJbtGyuXNSUjNYAj8gsmSECiLlmiETJ30nvq7agJTcRWXeuksh8bgngF7nnKmHmC5XkMFXDJSV52X2AC5hcSgjVly2JAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_3654_4710",
    width: 52,
    height: 9,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAJCAYAAAB9nA+YAAAACXBIWXMAAAsSAAALEgHS3X78AAAAaElEQVQ4T9WUMRKAMAgE79Lrm/i5vokPYKVjkUjIZMaw9RVZckAzQy/7if7wRFRAL3PDmtBfD49SE6WZpRHwUAG5HYHOJaB4gWyUyMKtjgr4HIXMe/T+lOqVA9YW/GpVU2iEkSHMrvwF490pKnRlPxQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_3654_4710",
    width: 33,
    height: 13,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAANCAYAAAAnigciAAAACXBIWXMAAAsSAAALEgHS3X78AAAAdklEQVQ4T8WUQQ7AIAgEF17Q8P83Nv4ATzTGVpE0ypw8rNmRREhVEeG6sXShCMjLGDSSWC2L8iX3kthV3tPKPBKnynuKgEhV0wQMzhYAAPYCJ+DIV9pF+iSKgNgOXngH1puyJ/pHDzdmy18xb9JLEjNM0CuaUQGTHDUBUuevMwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_3654_4710",
    width: 18,
    height: 40,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAoCAYAAADzL6qcAAAACXBIWXMAAAsSAAALEgHS3X78AAAAwElEQVRIS7WRQQ7DIAwEhyjnvilP75vyAXpCoim2F1PmbI1modRaWeH1pgKc0aFFEzQO63CWlOhZAwnRSAIJkcWUyKq5L8qUyEMWWTUNWRQhiaIaEEUe90UBQaTUgCDyaDUQiNQaWCzqMUVRTT8LdhdFNSNSRc9ZkBSN+BFlZkGiaDQLEiKLL1E0y6qBXUUeXg10omhWhFQU1YAoUjjAn6XUwL+LLNQagGP1txpm0UwN7H6j2RoYiDIS2DUtWwPwARrBMhwxw4d+AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_3654_4710",
    width: 14,
    height: 25,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAZCAYAAAABmx/yAAAACXBIWXMAAAsSAAALEgHS3X78AAAAfUlEQVQ4T63Pyw3DIBRFwYEKIvqvMaIDvEpEkPk6d2uPz3MopZjt9fbzUk5CGMEW1Iu9ByPEAM52C2c1/llcqdHAVcThqTkJX7hT47DIU7hzZk4CT4sn24KfMyHu/F+95WJdYwO2W4JtjQV4h1iAvcXeF+nXGBRHiA6cIbgAkBEjMWyULKwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_3654_4710",
    width: 18,
    height: 40,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAoCAYAAADzL6qcAAAACXBIWXMAAAsSAAALEgHS3X78AAAAwUlEQVRIS72VMQ7DIBAEF/r4Tfl5/KZ8AFdExsDt3oEylQs0mpWMnV6fUgDg+0bCArk+HCeKdZCRcWNF1oiAuKwTRRmKIlXTIq9s3zTr/fFU7StiB9SqDKxfD0AoArQqSaTwE7F5rGp/kYJV1YjYPAtXkYVbNJvXiaLz3EXAuCokGjEUReaFi57zpiJvVbjoiSliVfd5/ykCeFWFihh1niRSqiSRgixiVbKIkUqhf5oG+XvEmE10i2aERKOqkAjoZRew4TTjV61TmwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_3654_4710",
    width: 14,
    height: 25,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAZCAYAAAABmx/yAAAACXBIWXMAAAsSAAALEgHS3X78AAAAeUlEQVQ4T8WRQQrAIAwEV18g/v+N0h+kJ8HKmqy20DmK4ySYzAylwTBwVSQEZHY4P8TIq0uRTIsdT3ZFYC2H4gpJZFVJZMjiXM3KZ3dGWS7O/CSe7PmuCOxVgcNiabCHuFM9KgJEVKu0qMjfjdqJqm7Rk8NRmXxVpBv2QSQvq0XergAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_3654_4710",
    width: 40,
    height: 18,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAASCAYAAAApH5ymAAAACXBIWXMAAAsSAAALEgHS3X78AAAAl0lEQVRIS83SQQ6DMAxE0bHULZwpN2/PxAXMplNZYBWSOA5/Oasny7K8VXFoK5DjNquXN64fPAbtAr0sOhMrqupe7E4ZUNHvC7Yi2SjsD8h6oUAs9gQEYpBADNQFsidA/wJZFBSox94CshnQKiDLhDYBWQa0C8iioB4yBGiLwFpoONDWgyVyKNDWgt0KJA1oq8FOAdqusDsR/mGD2rfpSQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image10_3654_4710",
    width: 26,
    height: 14,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOCAYAAAAxDQxDAAAACXBIWXMAAAsSAAALEgHS3X78AAAAg0lEQVQ4T7WTSwrAIAxEJ9J9xftfseINpovSYsX4961EheckUUgCAKzHs0gIDpLb70XOi1mBxqj4qF1IiZP3SE3tQgnrQa3kKVOilxahkFQHYZRcSY12MEPu4V/pdst+PdopEyrfaGXfgoOoUxccZGVCNVHMinRNophRabcopSSOS38D2GE794227ToAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image11_3654_4710",
    width: 40,
    height: 18,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAASCAYAAAApH5ymAAAACXBIWXMAAAsSAAALEgHS3X78AAAAj0lEQVRIS83UsQ2AMAxE0YuUmpkYnZlYIFSHnGAUgh3Dr65w8SqnUgr+0rLhgsnaYUQaRisU+BTF9hVpOnAU1TYFaEXtKxK3K9AKA2oc4AD0QLEWBxiAs2FsGBgFY4+B0TDWBXrBRlCyW+DXMKYCPXBWGKuAf4KxE2jBeaNkGXiHm4mS5RFcFErWfTNfoGQHFgQz3U8IEuIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image12_3654_4710",
    width: 26,
    height: 14,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOCAYAAAAxDQxDAAAACXBIWXMAAAsSAAALEgHS3X78AAAAd0lEQVQ4T7XUSwrAIAwA0UnxAMX7n7F4A7uKtOI/OmvJw1gqMUas3Q/VIcEjALIKtYbnBY8MQzODS129A2BHgkdc64AV+FaEdgLaDzoB6FeX3ugkApXVWfsC2gV7b1NCANwupAZo5tX1AG0ZGgW09AvqrXB2cN4LzvItG+eQNUQAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseRank);
export default __webpack_public_path__ + "static/media/eclipseRank.f3c0acf581fbd3b19d6fad6e89900e24.svg";
export { ForwardRef as ReactComponent };